import { preInsert, preRemove, preSave } from '@/rxdb/defaultHooks';
import defaultReplication from '@/rxdb/defaultReplication';

export const contractualDocuments = {
    schema: {
        title: 'contractualDocuments schema',
        version: 2,
        description: 'describes a contractualDocument',
        primaryKey: 'id',
        type: 'object',
        properties: {
            id: { type: 'string', final: true, maxLength: 40 },
            projectId: { type: ['string', 'null'] },
            name: { type: ['string', 'null'] },
            code: { type: ['string', 'null'] },
            emitterId: { type: ['string', 'null'] },
            emissionDueDate: { type: ['string', 'null'] },
            emissionDate: { type: ['string', 'null'] },
            signers: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                },
            },
            predecessors: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                },
            },
            attachments: {
                type: ['array', 'null'],
                items: {
                    type: 'object',
                    properties: {
                        fileName: { type: ['string', 'null'] },
                        url: { type: ['string', 'null'] },
                    },
                },
            },
            createdBy: { type: ['string', 'null'], final: true },
            updatedAt: { type: ['string', 'null'] },
            deletedAt: { type: ['string', 'null'] },
            deletedBy: { type: ['string', 'null'] },
            createdAt: { type: ['string', 'null'] },
            updatedBy: { type: ['string', 'null'] },
            rootVersion: { type: ['string', 'null'] },
        },
    },
    options: {
        onCollectionCreated(projectId, rxCollection) {
            rxCollection.replicationState = defaultReplication(rxCollection, projectId);
            rxCollection.preRemove(preRemove, false);
            rxCollection.preInsert(preInsert, false);
            rxCollection.preSave(preSave, false);
        },
    },
    migrationStrategies: {
        1: (doc) => doc,
        2: (doc) => doc,
    },
};
